<template>
  <SentGeo />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import SentGeo from '@/components/content/SentGeo.vue'

export default defineComponent({
  name: 'SentGeoView',
  components: { SentGeo },
  setup(props, context) {
    const i18n = useI18n()
    context.emit('pageName', i18n.t('aside.menu.pages.sentGeo'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.sentGeo'))
    })
  }
})
</script>